import React from 'react';
import './nomatch.css';

const NoMatch = () => {
  return (
    <>
      <div class="nomatch">
        <h1>404 | Page Not Found </h1>
      </div>
    </>
  );
};

export default NoMatch;
